import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import qs from "qs";
import axios from "axios";
import { properCase } from "../../../../utility/properCase";
import { ReactComponent as CompletedIcon } from "../../../../assets/icons/completed.svg";
import { ReactComponent as PendingIcon } from "../../../../assets/icons/pending.svg";

// TODO : Add cleanup function for api calls

const DetailsPage = ({}) => {
    let location = useLocation();

    const [details, setDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");


    useEffect(async () => {
        let id = qs.parse(location.search)["?licenseID"];
        
        if (!id) return; // todo change to if else when adding cleanup function

        let [nswToken,error] = await authServices.getNSWAccessToken() ;

        if(error) {
            setErrorMsg(error);
            isLoading(false);
            return ;
        }

        setIsLoading(true);

        var data = qs.stringify({
            idList: JSON.stringify([id]),
            nsw_access_token: nswToken,
        });

        // console.log("data",qs.parse(data));

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "nswapi-getListDetails",
            headers: {
                token: authServices.getToken(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };
        
        axios(config)
            .then(function (response) {
                setIsLoading(false);
                if (response.data.status === "success") {
                    // console.log("DATA", response.data.result[id]);
                    setDetails(response.data.result[id]);
                } else {
                    //console.log("ERROR", response.data);
                    console.error(response);
                    setErrorMsg("Something Went Wrong");
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                console.error(error);
                setErrorMsg(error.message)
            });
    }, []);

    return (
        <div id="details-page">
            <div className="container-fluid p-0 m-0 w-100">
                <div className="card m-0 p-4 no-radius">
                    <h5 className="m-0">Search Result</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {isLoading ? (
                <div className="d-flex align-items-center justify-content-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3 m-0 w-100">
                    <div className="card p-5">
                        <div className="fw-bold mb-3">{details?.licenceDetail?.licensee}</div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3">
                            {details?.licenceDetail &&
                                Object.keys(details.licenceDetail)
                                    .filter((key) => key != "licensee")
                                    .map((key) => (
                                        <div key={key} className="col-md my-2">
                                            <span className="text-2">{key.length < 4 ? key.toUpperCase() : properCase(key)}</span>
                                            <span className="text-3 ms-3">{details.licenceDetail[key] || "-"}</span>
                                        </div>
                                    ))}
                        </div>

                        <hr />
                        {/* ################################## */}
                        <div className="fw-bold mb-3">Agency Details</div>
                        <div className="row row-cols-1">
                            <div key={"name"} className="col my-2">
                                <span className="text-2">Name</span>
                                <span className="text-3 ms-3">{details?.licensingAgency?.name || "-"}</span>
                            </div>
                            {details?.licensingAgency &&
                                Object.keys(details.licensingAgency)
                                    .filter((key) => key != "name")
                                    .map((key) => (
                                        <div key={key} className="col my-2">
                                            <span className="text-2">{key.length < 4 ? key.toUpperCase() : properCase(key)}</span>
                                            <span className="text-3 ms-3">{details.licensingAgency[key] || "-"}</span>
                                        </div>
                                    ))}
                        </div>
                        
                        {/* ################################## */}
                        <hr />
                        <div className="fw-bold mb-3">LICENCE CLASS AND CATEGORY</div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 p-0">
                            {details?.licenceClasses.length > 0 ?(
                                    details.licenceClasses.map((obj,i) => (
                                        <div key={i} className="col p-0">
                                            <LicenseClassCard info={obj} />
                                        </div>
                                    ))
                                ): (
                                    <div>NO DATA</div>
                                )
                            }
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

};


export default DetailsPage;

function LicenseClassCard({info}){

    // console.log(info);
    
    return (
        <div className="card m-2">
            <div className="d-flex p-3">
                <div className="d-flex align-items-center justify-content-center">
                    {info.isActive.toString().toLowerCase() === "false" ? (
                        <PendingIcon width="48" />
                    ) : (
                        <CompletedIcon width="48" />
                    )}
                </div>
                <div className="ms-3">
                    <b className="mb-4">{info.description}</b>
                    <div className="text-3">
                        <div>
                            <b className="d-inline-block" style={{width:"8ch"}}>Start Date</b>
                            - {info.startDate}
                        </div>
                        <div>
                            <b className="d-inline-block" style={{width:"8ch"}}>End Date</b>
                            - {info.endDate}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}